<template>
    <section id="events"  class=" bg-light">
        <div class="container" >
            <h2 class="my-3 text-capitalize font-weight-bold title">Event</h2> 
            <div class="row height-40 align-items-top">
                <ul class="list-inline event-list" >
                    <li class="col-sm-3 mb-3 list-inline-item"  v-for="(item, index) in items" :key="index">
                        <a href="">
                            <img  :src="item.image" :alt="item.name" class="img-fluid" >
                            <div class="cont small">
                                <p class="font-weight-bold">{{item.name}}</p>
                                <p>{{item.desc}} </p>
                                <span >NC COMIX | 만물상</span>
                            </div>
                        </a>
                    </li>
                   
                </ul>
            </div>
        </div>
    </section>
</template>
<style>
.event-list {margin:0 15px;}
.event-list li {border: 1px solid #e3e3e3; padding:0;    min-height: 30vh; vertical-align: top;}
.event-list li a {color:#363636}
.event-list .cont {padding:0 10px; padding-bottom:3px;}
</style>
<script>
export default {
    data () {
        return {
            items: [{image: 'https://buffimgs.plaync.com/buff/contents/0/636748/home_68c243629ae1a2ab2dff06ae3d2f4f92e88c398d151c5dfc0a14c1a3bbb5d6ae.jpg', name: '엄마, 나 그리고 꼬미',desc:'(MXM_마스터 아라미_S1)귀여운 사고뭉치아라미의 친구가 되어주세요!	'},
            {image: 'https://buffimgs.plaync.com/buff/contents/0/10069/9619ecda83fb2c964c147567af4cc4c8.jpg', name: '엄마, 나 그리고 꼬미',desc:'(MXM_마스터 아라미_S1)귀여운 사고뭉치아라미의 친구가 되어주세요!	'},
            {image: 'https://buffimgs.plaync.com/buff/contents/0/650576/f8294ab82e0e48144936c0db87d13e47.jpg', name: '엄마, 나 그리고 꼬미',desc:'(MXM_마스터 아라미_S1)귀여운 사고뭉치아라미의 친구가 되어주세요!	'}            
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Events.vue